// @flow

import React from 'react';

import './style/Spinner.css';
import { Spin } from 'antd';

export default (props) => {
    return (
        <Spin size="large" spinning={true} tip={props.tip}>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '100vh'
                }}
            ></div>
        </Spin>
    );
};



// WEBPACK FOOTER //
// ./demo/src/Spinner.js